<template>
  <div v-if="show && hasMessage" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="text-danger">Critical Note</h4>
      </div>

      <div class="modal-body">
        <p>{{ message }}</p>
      </div>

      <div class="modal-footer">
        <button class="btn-primary me-1" @click="confirmAndNavigate">
          Continue
        </button>
        <button class="btn-secondary" @click="handleCancel">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CriticalFunc",
  props: {
    message: { type: String, required: true, default: "" },
    targetUrl: { type: String, required: true, default: "" },
    onClose: Function,
  },
  data() {
    return {
      show: true,
    };
  },
  created() {
    // If message is empty, null, or undefined, redirect immediately
    if (!this.hasMessage) {
      this.confirmAndNavigate();
    } else {
      document.body.style.overflow = "hidden";
    }
  },
  unmounted() {
    document.body.style.overflow = "";
  },
  computed: {
    hasMessage() {
      return this.message && this.message.trim().length > 0;
    },
  },
  methods: {
    close() {
      document.body.style.overflow = "";
      this.onClose?.();
    },
    handleCancel() {
      if (!["", null, undefined].includes(this.targetUrl)) {
        this.close();
      } else {
        this.$router.go(-1);
        this.close();
      }
    },
    confirmAndNavigate() {
      this.$router.push(this.targetUrl);
      this.close();
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 4px;
  width: 90%;
  max-width: 500px;
}

.modal-header {
  margin-bottom: 20px;
}

.modal-footer {
  margin-top: 20px;
  text-align: right;
}

.btn-primary {
  background: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
}

.btn-secondary {
  background: #fff;
  border: 1px solid #d9d9d9;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
